/**
 * InputSearch Component - Template
 * ================================
 */

export const INPUT_SEARCH_TEMPLATE: string = `
<div class="ec-input-search-field" ng-class="$ctrl.getFieldClasses()">
  <label
    ng-if="$ctrl.hasLabelSlot"
    ng-attr-for="{{ $ctrl.resolvedId }}"
    ng-class="$ctrl.getLabelClasses()"
  ><span ng-transclude="labelSlot"></span></label>

  <div class="ec-input-search" ng-class="$ctrl.getWrapperClasses()">
    <div ng-class="$ctrl.getBoxClasses()">
      <span ng-class="$ctrl.getIconClasses()" ng-bind-html="$ctrl.trustedSearch" aria-hidden="true"></span>
      <input
        type="text"
        ng-attr-id="{{ $ctrl.hasLabelSlot ? $ctrl.resolvedId : undefined }}"
        ng-class="$ctrl.getInputClasses()"
        ng-model="$ctrl.value"
        ng-change="$ctrl.handleInput()"
        ng-keydown="$ctrl.handleKeydown($event)"
        ng-disabled="$ctrl.disabled"
        placeholder="{{ $ctrl.placeholder }}"
        ng-attr-aria-label="{{ $ctrl.ariaLabel }}"
        ng-attr-aria-describedby="{{ $ctrl.hasHelpSlot ? $ctrl.helpId : undefined }}"
      />
      <button
        ng-if="$ctrl.hasValue"
        type="button"
        ng-class="$ctrl.getClearClasses()"
        ng-click="$ctrl.clear()"
        aria-label="Limpiar búsqueda"
      >
        <span ng-class="$ctrl.getClearIconClasses()" ng-bind-html="$ctrl.trustedClear" aria-hidden="true"></span>
      </button>
    </div>

    <button
      ng-if="$ctrl.showFilter"
      type="button"
      ng-class="$ctrl.getFilterClasses()"
      ng-click="$ctrl.filter()"
      ng-disabled="$ctrl.disabled"
      aria-label="Filtros"
    >
      <span ng-class="$ctrl.getIconClasses()" ng-bind-html="$ctrl.trustedFilter" aria-hidden="true"></span>
    </button>
  </div>

  <span
    ng-if="$ctrl.hasHelpSlot"
    ng-attr-id="{{ $ctrl.helpId }}"
    ng-class="$ctrl.getHelpClasses()"
  ><span ng-transclude="helpSlot"></span></span>
</div>
`;

export default INPUT_SEARCH_TEMPLATE;
